import React, { FC, useEffect, useState } from 'react';
import { FormControl, FormHelperText, InputLabel, Select } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import { ProductSupplier } from 'src/interfaces/api/Product';
import { getJsonResponse } from 'src/utils/ApiUtils';
import api from 'src/config/api';
import useAuth from 'src/hooks/api/useAuth';

interface Props {
  value?: number;
  error?: boolean;
  helperText?: string;
  className?: any;
  fullWidth?: boolean;
  type: 'Hardware' | 'Virtual';
  onChange: (event: React.ChangeEvent<{ name?: string; value: unknown }>) => void;
}

const LegacyProductSupplierSelect: FC<Props> = React.forwardRef<any, Props>(
  ({ onChange, className, value, helperText, type, ...props }, ref) => {
    const [suppliers, setSuppliers] = useState<ProductSupplier[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string>();
    const { fetch } = useAuth();

    const getSuppliers = async (type: 'Hardware' | 'Virtual'): Promise<ProductSupplier[]> => {
      const { endpoint, ...options } = api.legacyProduct.getSuppliers(type);

      const response = await fetch(endpoint, options);

      try {
        const json = await getJsonResponse<{
          data: { suppliersHardware: ProductSupplier[] } | { suppliersVirtual: ProductSupplier[] };
        }>(response);
        return json.data[`suppliers${type}`].sort((supplierA: ProductSupplier, supplierB: ProductSupplier) =>
          supplierA.name.localeCompare(supplierB.name)
        );
      } catch (e) {
        throw new Error(e.message);
      }
    };

    useEffect(() => {
      getSuppliers(type)
        .then((data) => {
          setSuppliers(data);
          setLoading(false);
        })
        .catch((e) => {
          setError(e.message);
          setLoading(false);
        });
    }, []);

    if (loading) {
      return <Skeleton height={50} />;
    }

    if (error) {
      return <div style={{ color: '#f44336' }}>{error}</div>;
    }

    return (
      <FormControl ref={ref} className={className} variant='outlined' error={props.error} {...props}>
        <InputLabel>Fournisseur</InputLabel>
        <Select native value={value || ''} onChange={onChange} label='Fournisseur'>
          <option value='' />
          {suppliers.map((supplier, key) => (
            <option key={key} value={supplier.id}>
              {supplier.name}
            </option>
          ))}
        </Select>
        {helperText && <FormHelperText>{helperText}</FormHelperText>}
      </FormControl>
    );
  }
);

export default React.memo(LegacyProductSupplierSelect);
